import { useState } from 'react';
import { Box, Fade, Typography } from '@material-ui/core';
import TextSearch from './textSearch';
import DateTimeFilter from './dateTimeFilter';
import FilterType from './filterType';
import { useColumnFilter } from '../../hooks/useColumnFilter';
import Sort from './sorting';
import FilterIcons from './FilterIcon';

interface IFilterHeaderProps {
        headerName?: string;
        isSortingEnabled?: boolean;
        fieldName?: string;
        isFilteringEnabled?: boolean ;
}
const FilterHeader = ({ headerName = '', isSortingEnabled = true, fieldName = '', isFilteringEnabled= true}: IFilterHeaderProps) => {
    const [hovered, setHovered] = useState(false);
    const { handleOperatorChange, handleOnChangeValue,clearField, setValue, value, operator, setOperator, handleSortChange, sortDirection, handleClearSort, toggleFilter, isFilterOpen, date, handleOnDateChangeValue, isFilterActive} = useColumnFilter(fieldName, headerName)

    const renderFilters = () => {
        if (headerName === 'DATE/TIMESTAMP') {
            return <DateTimeFilter  filterName = {headerName} handleChange={handleOnDateChangeValue} value={date} />;
        } 
        if(isFilteringEnabled && isFilterOpen) {
            return <TextSearch filterName={headerName} handleChange={handleOnChangeValue} clearField= {clearField} value={value} setValue={setValue}/>;
        }
        return null;
    };

    return (
        <Box onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}   sx={{ position: 'relative', width: '100%' }} >
            <Box display="flex" alignItems="center" width={350}>
                <Typography variant="subtitle1">
                    {headerName}
                </Typography>
                {isFilteringEnabled && 
                <FilterIcons isHovered={hovered} isFilterActive={isFilterActive} toggleFilter={toggleFilter} isSortingEnabled ={!!(isSortingEnabled && sortDirection)}/>}
                {isSortingEnabled && (
                   <Sort sortDirection={sortDirection} handleSortChange={handleSortChange} isHovered={hovered} handleClearSort={handleClearSort}/>
                )}
            </Box>
            <Box>
            {(isFilteringEnabled && isFilterOpen) && 
            <Box>
                <FilterType filterName ={headerName} onChange={handleOperatorChange} value={operator} setValue={setOperator}/>
                {renderFilters()}
            </Box>
            }
            </Box>
        </Box>
    );
};

export default FilterHeader;